module.exports = __webpack_public_path__ + "static/media/kaze.0f833084.png";